import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionHandlerServerService {
  subscription_url = {
    getActiveSubscription:
      environment.URL + '/customer/api/subscription/active',
    cancelSubscription: environment.URL + 'kreta/subscription/cancel',
    upgradeSubscription: environment.URL + 'kreta/subscription/upgrade',
    downgradeSubscription: environment.URL + 'kreta/subscription/downgrade',
    getAllPlans: environment.URL + 'public/plan/retrieve/all',
    manageSubStatus: environment.URL + 'prashasan/subscription/manage/status',
    newSubscribe: environment.URL + 'kreta/subscription/newSubscribe',
    proratedCalcuate: environment.URL + 'kreta/subscription/prorateCalculate',
    fetchSubscriptionPayments: environment.URL + 'prashasan/subscription/fetch',
    pendingProration: environment.URL + 'kreta/subscription/pendingProration',
  };

  constructor(private http: HttpClient) {}

  /**
   * Pending in-band-upgrade proration for the header banner (null if none).
   * @param userId - customer user id
   */
  getPendingProration(userId: any): Observable<any> {
    return this.http.get(
      `${this.subscription_url.pendingProration}/${userId}`,
    );
  }

  /**
   * Fetches the active subscription details using User ID
   * @param userId - User ID
   * @returns {Observable<any>} - Observable containing the subscription details
   */
  getActiveSubscription(userId: number): Observable<any> {
    return this.http.get<any>(
      `${this.subscription_url.getActiveSubscription}/${userId}`
    );
  }

  /**
   * Cancels the active subscription
   * @param payload - The payload containing tenantId and planId
   * @returns {Observable<any>} - Observable containing cancellation response
   */
  cancelSubscription(
    payload: { planId: any; tenantId: any },
    userId
  ): Observable<any> {
    return this.http.post(
      `${this.subscription_url.cancelSubscription}/${userId}`,
      payload
    );
  }

  /**
   * Upgrades the subscription plan
   * @param payload - The payload containing tenantId and newPlanId
   * @returns {Observable<any>} - Observable containing upgrade response
   */
  upgradeSubscription(
    payload: {
      newPlanId: string;
      tenantId: any;
    },
    userId: any
  ): Observable<any> {
    return this.http.post(
      `${this.subscription_url.upgradeSubscription}/${userId}`,
      payload
    );
  }

  /**
   * Downgrades the subscription plan
   * @param payload - The payload containing tenantId and newPlanId
   * @returns {Observable<any>} - Observable containing downgrade response
   */
  downgradeSubscription(
    payload: {
      newPlanId: string;
      tenantId: any;
    },
    userId: any
  ): Observable<any> {
    return this.http.post(
      `${this.subscription_url.downgradeSubscription}/${userId}`,
      payload
    );
  }

  /**
   * Retrieves all available subscription plans from Cashfree
   * @returns {Observable<any>} - Observable containing available plans
   */
  getAllPlans(): Observable<any> {
    return this.http.get(this.subscription_url.getAllPlans);
  }

  manageSubscriptionStatus(bodyParmas: any): Observable<any> {
    return this.http.post(this.subscription_url.manageSubStatus, bodyParmas);
  }

  newSubscription(params, userId: any): Observable<any> {
    return this.http.post(
      `${this.subscription_url.newSubscribe}/${userId}`,
      params
    );
  }

  proratedCalculation(params, userId: any): Observable<any> {
    return this.http.post(
      `${this.subscription_url.proratedCalcuate}/${userId}`,
      params
    );
  }

  refreshTenantSubscriptionDetails(tenantId): Observable<any> {
    return this.http.get(
      `${this.subscription_url.fetchSubscriptionPayments}/${tenantId}`
    );
  }
}
